import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Config } from './config';
import { catchError, map, Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ADS_REFRESH_TOKEN_KEY, ADS_ROLE_KEY, ADS_TOKEN_KEY } from './auth.service';

export interface ExchangeTokenReponse {
    token: string;
    expiration: string;
    roles: string[];
    forcePasswordReset: boolean;
    passwordExpirationDays: number;
    refreshToken: string;
    refreshTokenExpiration: string;
}

@Injectable({
    providedIn: 'root'
})
export class PerispekService {

    /** Use HTTP that runs outside of Angular's stuff */
    private http3rdParty: HttpClient;

    constructor(
        private httpBackend: HttpBackend
    ) {
        this.http3rdParty = new HttpClient(httpBackend);
    }

    public exchangeToken(token: string): Observable<ExchangeTokenReponse> {
        const url = Config.urls.perispek.exchangeToken;
        const bearerTokenStr = `Bearer ${token}`;
        return this.http3rdParty.post<ExchangeTokenReponse>(url, {}, {
            headers: {
                Authorization: bearerTokenStr
            }
        })
    }

    public canActivateWithToken(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.exchangeToken(route.queryParams.token).pipe(
            map((result) => {
                if(result.token) {
                    sessionStorage.setItem(ADS_TOKEN_KEY, result.token);
                    sessionStorage.setItem(ADS_ROLE_KEY, result.roles?.toString());
                    localStorage.setItem(ADS_REFRESH_TOKEN_KEY, result.refreshToken);

                    return true;
                }
                return false;
            }),
            catchError(() => {
                return of(false);
            })
        );
    }
}
